import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree';

export const NewsModel = types.model('NewsModel', {
    title: '',
    description: '',
    cta_link: '',
    cta_label: '',
    image: '',
});

export type TypeNewsModel = Instance<typeof NewsModel>;

export default NewsModel;
